module.exports = __webpack_public_path__ + "static/media/Resultat-pas-valides.aef999a4.svg";